import { cn, InfoHint } from '@eo/shared';

import { TERM_HELP } from './constants';
import { formatHours } from './helpers';
import type { ClientForecastProps } from './types';

// Where the month is heading: the higher of logged plus the open tasks' remaining
// estimates, and logged hours carried forward at the month's pace so far.
export function ClientForecast({ forecast, engagement }: ClientForecastProps) {
  const above = forecast.forecast > engagement;
  return (
    <dl
      data-testid="client-forecast"
      className="flex flex-col gap-1 border-l-2 border-border-faint pl-3"
    >
      <dt className="flex items-center gap-1 text-xs text-text-tertiary">
        Forecast
        <InfoHint term="Forecast">{TERM_HELP.forecast}</InfoHint>
      </dt>
      <dd className="text-2xl leading-[26px] tabular-nums text-text-secondary">
        {formatHours(forecast.forecast)}
      </dd>
      <dd className={cn('text-xs', above ? 'text-destructive' : 'text-text-tertiary')}>
        {above
          ? `Above engagement by ${formatHours(forecast.forecast - engagement)}`
          : 'Within engagement'}
      </dd>
      <dd className="text-xs text-text-tertiary">
        {formatHours(forecast.logged)} logged + {formatHours(forecast.remaining)} still estimated on
        open tasks; at this month’s pace {formatHours(forecast.pace)}. {forecast.estimatedOpenTasks}{' '}
        of {forecast.openTasks} open tasks estimated.
      </dd>
    </dl>
  );
}
